(function ($) {

	/* trigger when page is ready */
	$(document).ready(function (){

    var winW = $(window).width();

    var promainH = $('.pro-main').outerHeight();
    var headerH = $('.site-header').outerHeight();
    var topScroll = promainH + headerH - 27;

    $(window).on('load', function(){
      var promainH = $('.pro-main').outerHeight();
      var headerH = $('.site-header').outerHeight();
      var topScroll = promainH + headerH + 170;

      console.log('promainH: ' + promainH);
      console.log('headerH: ' + headerH);
      console.log('topScroll: ' + topScroll);

      $(window).scroll(function(){

        var promainH = $('.pro-main').outerHeight();
        var headerH = $('.site-header').outerHeight();

        if ($(window).scrollTop() > topScroll) {
          //$('.mini-nav').addClass('fix').css('top', headerH);
					$('.mini-nav').addClass('fix').css('top', 0);
        } else {
          $('.mini-nav').removeClass('fix').css('top', '0');
        }
      });
    });


		var proSimgAlt = $('.pro-specs img:nth-child(2)').attr('alt');
		if ( proSimgAlt != 'especificaciones' ) {
			$('.pro-specs img').remove();
		}
		console.log('proSimgAlt: ' + proSimgAlt);

		var proFimgAlt1 = $('.pro-features img:nth-child(1)').attr('alt');
		var proFimgAlt2 = $('.pro-features img:nth-child(2)').attr('alt');

		console.log('proFimgAlt1: ' + proFimgAlt1);
		console.log('proFimgAlt2: ' + proFimgAlt2);

		if ( proFimgAlt1 != 'claves1' ) {
			$('.pro-features').parent().remove();
			$('.mini-nav .li-features').remove();
		}


    var sec = 0;
    $('.product-single__description.rte > h6').each(function(index){
      sec++;
      $(this).addClass('hsec');
      $(this).nextUntil('h6').wrapAll('<div class="pro-sec pro-sec-'+ sec +'"></div>');
    });

    var sec2 = 0;
    $('.second-description.rte > h6').each(function(index){
      sec2++;
      $(this).addClass('hsec');
      $(this).nextUntil('h6').wrapAll('<div class="pro-sec pro-sec-'+ sec2 +'"></div>');
    });

    // var sec3 = 0;
    // $('.pro-specs .inner-text > h6').each(function(index){
    //   sec3++;
    //   $(this).addClass('hsec');
    //   $(this).nextUntil('h6').wrapAll('<div class="pro-sec pro-sec-'+ sec3 +'"></div>');
    // });

    var sec3 = 0;
    $('.acordeon.rte > h6').each(function(index){
      sec3++;
      $(this).addClass('hsec');
      $(this).nextUntil('h6').wrapAll('<div class="pro-sec pro-sec-'+ sec3 +'"></div>');
    });

    $('.acordeon.rte .pro-sec-3 > h3').each(function(){
      $(this).addClass('h3-acor');
      $(this).nextUntil('h3').wrapAll('<div class="main-info"></div>')
    });

    $('.acordeon.rte .pro-sec-3 .main-info > h4').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h4').wrapAll('<div class="hide-info"></div>')
    });

    $('.acordeon.rte .pro-sec-3 .main-info h4').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });

    $('.acordeon.rte .pro-sec-3 .hide-info p').each(function(){
      var nuevo_span = $(this).html().split('</strong>')[0] + '</strong> <span class="text">' + $(this).html().split('</strong>')[1] + '</span>';
      $(this).html(nuevo_span);
    });

    var word = 'yes';
    var re = new RegExp('[^<\\/](' + word + ')', 'g');
    $('.acordeon.rte .pro-sec-4 p').each(function() {
        $(this).html( $(this).html().replace( re, ' <span class="check">$1</span>' ) );
    });

    if ( winW > 830 ) {
      $('.mini-nav li.li-features').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-features').offset().top - 160)
        }, 1000);
      });

      $('.mini-nav li.li-specs').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-specs').offset().top - 120)
        }, 1000);
      });

      $('.mini-nav li.li-videos').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-videos').offset().top - 120)
        }, 1000);
      });

      $('.mini-nav li.li-pro').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('#shopify-section-product-recommendations').offset().top - 120)
        }, 1000);
      });
    } else {
      $('.mini-nav li.li-features').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-features').offset().top - 200)
        }, 1000);
        $('.mini-nav ul').slideToggle(300);
      });

      $('.mini-nav li.li-specs').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-specs').offset().top - 200)
        }, 1000);
        $('.mini-nav ul').slideToggle(300);
      });

      $('.mini-nav li.li-videos').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('.pro-videos').offset().top - 200)
        }, 1000);
        $('.mini-nav ul').slideToggle(300);
      });

      $('.mini-nav li.li-pro').click(function(){
        $("html, body").delay(1).animate({
          scrollTop: ($('#shopify-section-product-recommendations').offset().top - 200)
        }, 1000);
        $('.mini-nav ul').slideToggle(300);
      });
    }



    if ( winW < 830 ) {
      $('.mini-nav .menu').click(function(){
        $('.mini-nav ul').slideToggle(300);
        $('.mini-nav .menu span').toggleClass('clicked');
      });
    }

		if ( $('.pro-videos').length < 1 ) {
			$('.mini-nav li.li-videos').hide(1);
		}

	});

}(window.jQuery || window.$));
